/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_PRESENTATION = gql`
  query GetPresentation($filter: UniqPresentationFilterInput!) {
    getPresentation(filter: $filter) {
      id
      name
      sections {
        alias
        description
        id
        images
        img1
        img2
        isVisible
        name
        regMode
        position
        costumeTypes {
          code
          description
          id
          images
          img1
          img2
          isMandatory
          isSingleFeature
          isVisible
          name
          price
          minDownPayment
          costumeFeatures {
            alias
            basePrice
            code
            currency
            desc
            id
            images
            img1
            isLabel
            img2
            isMandatory
            isSingleAttribute
            isVisible
            maxInventory
            name
            costumeAttributes {
              desc
              dynaInventory
              id
              isLabel
              isMandatory
              isDynamic
              isSingleVal
              isVisible
              name
              images
            }
            featurePosition
          }
        }
      }
      status
      year
      type
    }
  }
`;
